class APIS {
	apis() {
		return {
			OutboundEmailsList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/outbound-emails/list'
			},
			sendEmail: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/outbound-emails/send'
			},
			addRecipients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/create'
			},
			emailsCampaignCreate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/emails-campaign/create'
			},
			emailsCampaignUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/emails-campaign/update'
			},
			emailsCampaignFetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/emails-campaign'
			},
			emailsCampaignDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/emails-campaign/delete'
			},
			emailTemplateList: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-template/list'
			},
			emailTemplateAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-template/add'
			},
			emailTemplateUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-template/update'
			},
			emailTemplateDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-template/delete'
			},
			emailTemplateParams: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/email-template/params'
			},
			createEmailRecipients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/create'
			},
			senderEmailAdd: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sender-emails/add'
			},
			senderEmailFetch: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sender-emails/list'
			},
			senderEmailFetchByDomain: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sender-emails/list-by-domain'
			},
			senderEmailDelete: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sender-emails/delete'
			},
			senderEmailUpdate: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/sender-emails/update'
			},
			deleteRecipients: {
				headers: {
					'xt-user-token': null
				},
				method: 'post',
				path: '/template/recipients/delete'
			},

		}
	}
}

export default new APIS();